<div class="view-wrapper">
  <dx-toolbar class="theme-dependent" [class.scrolled]="isContentScrolled">
    <dxi-item location="before">
      <div class="header-text">User Profile</div>
    </dxi-item>
    <dxi-item location="after" locateInMenu="never">
      <dx-button
        text="Cancel"
        stylingMode="outlined"
        type="normal"
        [disabled]="!isDataChanged"
        (onClick)="cancel()"
      >
      </dx-button>
    </dxi-item>
    <dxi-item location="after" locateInMenu="never">
      <dx-button
        [disabled]="!isDataChanged"
        text="Save"
        icon="save"
        type="default"
        stylingMode="contained"
        (onClick)="save()"
      >
      </dx-button>
    </dxi-item>
  </dx-toolbar>

  <dx-load-panel
    container=".view-wrapper-scroll"
    [visible]="isLoading"
    [showPane]="false"
    [position]="{ of: 'user-profile' }"
  >
  </dx-load-panel>
  <dx-scroll-view class="view-wrapper-scroll" (onScroll)="scroll($event)">
    <div *ngIf="!isLoading" class="cards-container">
      <profile-card
        class="profile-card basic-info-card"
        title="Basic Info"
        [colCount]="4"
        [cardData]="profileData"
        [items]="basicInfoItems"
        (dataChanged)="dataChanged()"
      >
        <div class="basic-info-top-item" top-item>
          <form-photo
            [link]="profileData?.image"
            [editable]="true"
            [size]="80"
          ></form-photo>
          <div>
            <div class="title-text">{{ profileData.name }}</div>
            <div class="subtitle-text with-clipboard-copy">
              <span>ID: {{ profileData.id }}</span>
              <dx-button
                icon="copy"
                class="copy-clipboard-button"
                stylingMode="text"
                [activeStateEnabled]="false"
                [focusStateEnabled]="false"
                [hoverStateEnabled]="false"
                (onClick)="copyToClipboard(profileData.id, $event)"
              ></dx-button>
            </div>
            <dx-button
              text="Change Password"
              class="change-password-button"
              stylingMode="contained"
              [icon]="(screen.xSmallScreenChanged | async) ? null : 'lock'"
              (onClick)="changePassword()"
            ></dx-button>
          </div>
        </div>
        :
      </profile-card>

      <profile-card
        class="profile-card contacts-card"
        title="Contacts"
        [cardData]="profileData"
        [items]="contactItems"
        (dataChanged)="dataChanged()"
      >
        <div top-item>
          <div class="image-wrapper">
            <i class="dx-icon dx-icon-mention"></i>
          </div>
          <div>
            <div class="title-text">{{ profileData.phone | phone }}</div>
            <div class="subtitle-text with-clipboard-copy">
              {{ profileData.email }}
              <dx-button
                icon="copy"
                class="copy-clipboard-button"
                stylingMode="text"
                [activeStateEnabled]="false"
                [focusStateEnabled]="false"
                [hoverStateEnabled]="false"
                (onClick)="copyToClipboard(profileData.email, $event)"
              ></dx-button>
            </div>
          </div>
        </div>
      </profile-card>

      <profile-card
        class="profile-card address-card"
        title="Address"
        [cardData]="profileData"
        [items]="addressItems"
        (dataChanged)="dataChanged()"
      >
        <div top-item>
          <div class="image-wrapper">
            <i class="dx-icon dx-icon-map"></i>
          </div>
          <div>
            <div class="title-text">
              {{ profileData.address }}, {{ profileData.city }},
              {{ profileData.state }}, {{ profileData.country }}
            </div>
          </div>
        </div>
      </profile-card>
    </div>
  </dx-scroll-view>
</div>

<change-profile-password-form
  [(visible)]="isChangePasswordPopupOpened"
></change-profile-password-form>
